module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Mail-locked-f8009b233d9b66b3025da363f6474d3c.svg";